import { jsx as _jsx } from "react/jsx-runtime";
import { Component, createRef } from "react";
import { OptionsLine } from "shared-ui-components/lines/optionsLineComponent.js";
/**
 * A wrapper of OptionsLineComponent that supports options obtained via Observable.
 * Using an Observable allows for dynamic updates to the options list.
 */
export class DynamicOptionsLine extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
        };
        this._observer = null;
        this._optionsLineRef = createRef();
    }
    onOptionsChanged(value) {
        this.setState({ options: value });
    }
    componentDidUpdate() {
        // OptionsLine component does not update on prop changes, since it uses its
        // own shouldUpdateMethod. Hopefully we can change this later.
        if (this._optionsLineRef.current) {
            this._optionsLineRef.current.forceUpdate();
        }
    }
    componentDidMount() {
        this._observer = this.props.optionsObservable.add(this.onOptionsChanged.bind(this));
    }
    componentWillUnmount() {
        if (this._observer) {
            this.props.optionsObservable.remove(this._observer);
            this._observer = null;
        }
    }
    render() {
        // Exclude optionsObservable from the props passed to OptionsLine
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { optionsObservable, ...rest } = this.props;
        return _jsx(OptionsLine, { ...rest, options: this.state.options, ref: this._optionsLineRef });
    }
}
//# sourceMappingURL=dynamicOptionsLineComponent.js.map